document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.new-collections-mobile .collapsible-menu-item');
    items.forEach(function (item) {
        var summary = item.querySelector('.collapsible-menu-summary');
        var content = item.querySelector('.collapsible-menu-content');
        if (summary && content) {
            summary.addEventListener('click', function (e) {
                items.forEach(function (other) {
                    if (other !== item) {
                        var otherContent = other.querySelector('.collapsible-menu-content');
                        if (otherContent) {
                            otherContent.style.maxHeight = '0';
                            other.setAttribute('data-active', 'false');
                        }
                    }
                });
                if (content.style.maxHeight && content.style.maxHeight !== '0px') {
                    content.style.maxHeight = '0';
                    item.setAttribute('data-active', 'false');
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    item.setAttribute('data-active', 'true');
                }
            });
        }
    });
});

var details = [...document.querySelectorAll('.new-collections details')];
document.addEventListener('click', function (e) {
    if (!details.some(f => f.contains(e.target))) {
        details.forEach(f => f.removeAttribute('open'));
    } else {
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
    }
});